module.exports = __webpack_public_path__ + "static/media/ship.0b769172.svg";